import type React from 'react'

/** Enter commits a panel text field by blurring it — the field's `onBlur` does the commit. */
export function handleBlurOnEnter(e: React.KeyboardEvent<HTMLInputElement>): void {
  if (e.key === 'Enter') {
    e.preventDefault()
    ;(e.target as HTMLInputElement).blur()
  }
}
